// src/app/app.routes.ts

import { Routes } from '@angular/router';
import { authenticationGuard, authorizationGuard, ErrorComponent, WhoamiComponent } from 'shared-frontend';
import { PERMISSION_SETS } from './core/roles.constants';
import { EVENT_SUBMISSION_PATHS } from './core/app.paths';


const loadEventSubmissionRoutes = () => import('./features/announcement.routes').then(m => m.EVENT_SUBMISSION_ROUTES);
const loadNewsletterHeaderRoutes = () => import('./features/newsletter-header.routes').then(m => m.NEWSLETTER_HEADER_ROUTES);
const loadRecipientRoutes = () => import('./features/recipient.routes').then(m => m.RECIPIENT_ROUTES);

export const routes: Routes = [
    {
        path: '',
        canActivate: [authenticationGuard], // ← Everything requires authentication
        children: [
            { path: '', redirectTo: EVENT_SUBMISSION_PATHS.home, pathMatch: 'full' }, // Default
            { path: 'whoami', component: WhoamiComponent }, // Login debug page
            { path: '', loadChildren: loadEventSubmissionRoutes },
            { path: '', loadChildren: loadRecipientRoutes },
            { path: '', loadChildren: loadNewsletterHeaderRoutes}
        ]
    },
];
